export default __webpack_public_path__ + "static/media/beneficiarioMobile.c6928ba8.gif";